<div class="search">
  <input
    *ngIf="!isDatePicker"
    #searchInput
    type="text"
    class="form-control search-control"
    [placeholder]="placeholder | translate"
    [value]="initialValue || ''"
  />
  <app-date-picker
    *ngIf="isDatePicker"
    #datePicker
    class="form-control search-control date-picker img-invert2"
    [placeholder]="placeholder | translate"
    (dateSelected)="onDatePicked($event)">
  </app-date-picker>
</div>
